export default {
  // 接口地址
  // 任金玺电脑服务器后端
  // baseURL: 'http://172.21.2.215:8000/',
  // 测试机服务器后端
  // baseURL: 'http://192.168.8.6:8080/',
  // 正式服务器后端
  // baseURL: "http://120.48.69.30:80/",
  // 线上打包
  baseURL: "./",
  isDev: true
};



// WEBPACK FOOTER //
// ./src/services/env.js